<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Estrutura Orgânica" pageTitle="Estrutura Orgânica" />
            <OrganicStructureContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import OrganicStructureContent from '../OrganicStructure/OrganicStructureContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'OrganicStructurePage',
    components: { MainHeader, PageTitle, OrganicStructureContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
